export const bankCardHeader = {
    autoForward: true,
    displayCardBalance: false,
};
